import MediaLibraryBulkDelete from './MediaLibraryBulkDelete';

export default MediaLibraryBulkDelete;
